module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "table-body"
  }, [_c('hr'), _c('div', {
    staticClass: "table-row table-padding"
  }, [_vm._m(0), _c('div', {
    staticClass: "table-col title"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('integrations.title.rdStation')))]), _c('div', {
    staticClass: "light-gray-text"
  }, [_vm._v(_vm._s(_vm.$t('integrations.subtitle.rdStationMarketing')))])]), _c('div', {
    staticClass: "table-col table-col-collapsed actions"
  }, [(_vm.rdstation_authorized && !_vm.show_form_rd) ? _c('button', {
    staticClass: "btn btn-clean btn-nylas",
    on: {
      "click": _vm.open
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.configure')))]) : _vm._e(), (!_vm.rdstation_authorized && !_vm.show_form_rd) ? _c('button', {
    staticClass: "btn btn-clean btn-nylas",
    on: {
      "click": _vm.connect
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.connect')))]) : _vm._e()])])]), (_vm.show_form_rd) ? _c('div', {
    staticClass: "form",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "id": "closeFormButton",
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.show_form_rd = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _c('div', {
    staticClass: "form-group margin-top"
  }, [_c('span', {
    staticClass: "triggers-integrations index"
  }, [_c('h4', [_c('strong', [_vm._v(_vm._s(_vm.$t('integrations.label.rdStationMarketing.contactsDistributionTitle')))])])]), _c('div', {
    staticClass: "sub-index intermediate-index"
  }, [_vm._v(_vm._s(_vm.$t('integrations.label.rdStationMarketing.choosenModel')))]), _c('div', {
    staticClass: "sub-index"
  }, [_vm._v(_vm._s(_vm.$t('integrations.label.rdStationMarketing.choosenModelInfo')))]), _c('span', {
    staticClass: "index index-second"
  }, [_vm._v(_vm._s(_vm.$t('integrations.label.rdStationMarketing.chooseModelAction')) + ":")]), _c('div', {
    staticClass: "new_input"
  }, [_c('div', {
    staticClass: "checkbox-inline margin-top",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        return _vm.toggleUserCarouselRd()
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.show_carousel
    }
  }), _c('label', {
    staticClass: "control-label",
    staticStyle: {
      "max-width": "250px",
      "margin-right": "200px",
      "margin-top": "5px",
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "text_select"
  }, [_vm._v(_vm._s(_vm.$t('integrations.label.rdStationMarketing.propertyDistribution')))])])]), (_vm.show_carousel && _vm.show_id) ? _c('properties-select', {
    attrs: {
      "id": _vm.custom_field_id
    },
    on: {
      "selected": _vm.property_updated
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-left": "0px"
    }
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "checkbox-inline margin-top",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        return _vm.toggleUseCarouselRd()
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.use_carousel
    }
  }), _c('label', {
    staticClass: "control-label",
    staticStyle: {
      "min-width": "465px",
      "margin-right": "35px",
      "margin-top": "5px",
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "text_select"
  }, [_vm._v(_vm._s(_vm.$t('integrations.label.rdStationMarketing.simpleCarouselDistribution')))])])])])])]), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-left": "0px"
    }
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "checkbox-inline margin-top",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        return _vm.toggleUseResponsibleRd()
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.show_user_carousel
    }
  }), _c('label', {
    staticClass: "control-label",
    staticStyle: {
      "min-width": "465px",
      "margin-right": "35px",
      "margin-top": "5px",
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "text_select"
  }, [_vm._v(_vm._s(_vm.$t('integrations.label.rdStationMarketing.responsibleDistribution')))])])])])])])]), (_vm.property && _vm.show_carousel) ? _c('properties-Table', {
    attrs: {
      "selected": _vm.property
    },
    on: {
      "property_id": _vm.property_id_updated
    }
  }) : _vm._e()], 1), (_vm.use_carousel) ? _c('div', {
    staticClass: "form-group margin-top"
  }, [_c('div', {
    staticClass: "info info-rd"
  }, [_vm._v(_vm._s(_vm.$t('integrations.label.rdStationMarketing.receiveLeadsInfo')))])]) : _vm._e(), (_vm.use_carousel) ? _c('div', {
    staticClass: "form-group margin-top"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "rd_url",
      "name": "rd_url",
      "type": "text",
      "disabled": !_vm.has_configured_rd_carousel && _vm.use_carousel,
      "readonly": _vm.rd_carousel != null
    },
    domProps: {
      "value": _vm.rd_url
    }
  }), _c('button', {
    staticClass: "btn btn-primary btn-copy",
    attrs: {
      "id": "btn-copy-rd-url",
      "disabled": !_vm.has_configured_rd_carousel && _vm.use_carousel
    },
    on: {
      "click": _vm.copyURLrd
    }
  }, [_vm._v(_vm._s(_vm.copied_rd ? _vm.$t('general.actions.copied') : _vm.$t('general.actions.copy')))]), (_vm.use_carousel) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#rd-carousel-modal"
    },
    on: {
      "click": _vm.loadRdCarouselData
    }
  }, [_vm._v(_vm._s(_vm.$t('integrations.label.setCarousel')))]) : _vm._e()]) : _vm._e(), (_vm.show_user_carousel) ? _c('div', {
    staticClass: "form-group margin-top"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "rd_url",
      "name": "rd_url",
      "type": "text"
    },
    domProps: {
      "value": _vm.rd_url
    }
  }), _c('button', {
    staticClass: "btn btn-primary btn-copy",
    attrs: {
      "id": "btn-copy-rd-url"
    },
    on: {
      "click": _vm.copyURLrd
    }
  }, [_vm._v(_vm._s(_vm.copied_rd ? _vm.$t('general.actions.copied') : _vm.$t('general.actions.copy')))])]) : _vm._e(), _c('br'), _c('hr', {
    staticClass: "lines-div",
    staticStyle: {
      "padding-bottom": "20px"
    }
  }), _c('span', {
    staticClass: "triggers-integrations index"
  }, [_c('h4', [_c('strong', [_vm._v(_vm._s(_vm.$t('integrations.label.rdStationMarketing.sendContactsTitle')))])])]), (!_vm.rdstation_authorized) ? _c('div', {
    staticClass: "info info-rd"
  }, [_vm._v(_vm._s(_vm.$t('integrations.label.rdStationMarketing.chooseContactTag')))]) : _vm._e(), _c('div', {
    staticClass: "triggers-integrations"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "checkbox-inline on-created",
    on: {
      "click": function($event) {
        return _vm.checkboxSelectSaleRD()
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.selectedSaleRD
    }
  }), _c('label', {
    staticClass: "text_label",
    class: {
      disabled: !_vm.rdstation_authorized && _vm.rd_station_setting.use_carousel
    }
  }, [_vm._v(_vm._s(_vm.$t('integrations.label.rdStationMarketing.customerTag')))])])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 left"
  }, [_c('div', {
    staticClass: "checkbox-inline on-created",
    on: {
      "click": function($event) {
        return _vm.checkboxSelectOpportunityRD()
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.selectedOpportunityRD
    }
  }), _c('label', {
    staticClass: "text_label",
    class: {
      disabled: !_vm.rdstation_authorized && _vm.rd_station_setting.use_carousel
    }
  }, [_vm._v(_vm._s(_vm.$t('integrations.label.rdStationMarketing.stagesTag')))])])]), (_vm.selectedOpportunityRD) ? _c('div', {
    staticClass: "col-md-4 rd-stages"
  }, [_c('stages-select', {
    attrs: {
      "integration": "rd_station",
      "filter_item_selected_ids": _vm.rd_station_setting.triggers.stages
    },
    on: {
      "item-selected-items": _vm.itemSelectedItems
    }
  })], 1) : _vm._e()])]), _c('properties-matching', {
    attrs: {
      "properties_matching": _vm.rd_station_setting.properties_matching,
      "integration_name": "RD Station",
      "api_fields": _vm.api_fields
    },
    on: {
      "matching-updated": _vm.matchingUpdated
    }
  }), _c('div', {
    staticClass: "row vertical-aligned"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "pull-right btn btn-primary",
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.save')))]), _c('button', {
    staticClass: "pull-right btn btn-primary",
    class: _vm.rdstation_authorized ? 'btn-danger' : 'btn-primary',
    on: {
      "click": _vm.redirectToRdstationOauthUrl
    }
  }, [_vm._v(_vm._s(_vm.rdstation_authorized ? _vm.$t('general.actions.disconnect') : _vm.$t('general.actions.connect')))])])])], 1) : _vm._e(), _c('carousel-modal', {
    ref: "rd_carousel_modal",
    attrs: {
      "id": "rd-carousel-modal",
      "modal-title": _vm.modalTitle(),
      "kind": "rd"
    },
    on: {
      "savedCarousel": _vm.fillRdCarousel
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-col table-col-collapsed"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/rdstation.jpg"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4e052822!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/configuration/integrations/rd_station.vue
// module id = 1111
// module chunks = 1